import { ComponentStyleConfig } from '@chakra-ui/react';

const Button = {
   baseStyle: {
      borderRadius: 'base',
      flexShrink: 0,
   },
   variants: {
      cta: {
         bgColor: 'brand.500',
         color: 'white',
         _hover: {
            opacity: 0.8,
         },
         _focusVisible: {
            boxShadow: 'outline',
         },
      },
      secondary: {
         bgColor: 'gray.300',
         color: 'black',
         _hover: {
            opacity: 0.8,
         },
         _focusVisible: {
            boxShadow: 'outline',
         },
      },
      outline: {
         borderColor: 'gray.300',
      },
      proDark: {
         bgColor: 'black',
         color: 'white',
         px: 6,
         _focusVisible: {
            boxShadow: 'outline',
         },
         '& > span': {
            color: 'pro.400',
            display: 'contents',
         },
      },
      proLight: {
         bgColor: 'pro.400',
         color: 'black',
         px: 6,
         _hover: {
            opacity: 0.8,
         },
         _focusVisible: {
            boxShadow: 'outline',
         },
         '& > span': {
            color: 'white',
            display: 'contents',
         },
      },
   },
} satisfies ComponentStyleConfig;

export default Button;
